import React, { Component } from 'react';
import PeoplesRenderGet from '../components/peoples/peoples';
import { RequestInfoGet, pageSrc, serverUrl } from '../lib/funApp/general'

let targetUrl = '/src/peoples'

if(pageSrc.includes(targetUrl)){
  targetUrl = serverUrl + pageSrc
}else{
  targetUrl = serverUrl + targetUrl
}

class PeoplesGet extends Component {

  state = {
    peoples: [],
    links: {}
  }

  componentDidMount() {
    fetch(targetUrl ,RequestInfoGet)
    .then(res => res.json())
    .then((data) => {
      this.setState({ links: data._links })
      this.setState({ peoples: data.items })
    })
    .catch()
  }

  render() {
    return (
      <PeoplesRenderGet peoples={[this.state.peoples,this.state.links]} />
    )
  }

}

export default PeoplesGet;
